import { NavBar } from '../../components/NavBar';
import { SharedFooter } from '../../components/SharedFooter';
import { EventsSection } from '../home/EventsSection';

export function EventsPage() {
  return (
    <div className="min-h-screen bg-bg pt-[72px]">
      <NavBar
        variant="light"
        links={[
          { label: 'Drawing Events', href: '/events' },
          { label: 'Artists', href: '/artists' },
          { label: 'Models', href: '/models' },
        ]}
      />
      <EventsSection showEmptyState />
      <SharedFooter />
    </div>
  );
}
